import * as React from "react";
import Autosuggest from "react-autosuggest";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import { InputProps } from "../../types/InputProps";
import SearchIcon from "@material-ui/icons/Search";
import { styles } from "./InputCustomerAutocomplete.style";
import { Customer } from "../../types/Customer";

type InputCustomerAutocompleteState = {
    value: string;
    suggestions: Customer[];
};

class InputCustomerAutocomplete extends React.Component<InputProps & WithStyles<typeof styles>, InputCustomerAutocompleteState> {

    state: InputCustomerAutocompleteState = {
        value: "",
        suggestions: []
    };

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    }

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    }

    handleChange = (event, { newValue }) => {       
        this.setState({
            value: newValue,
        });
    }

    handleSuggestionSelected = (event, { suggestion }) => {
        event.preventDefault();
        this.props.onChange(suggestion, event.target);
    }

    renderInput(inputProps) {
        const { classes, ref, ...other } = inputProps;
    
        return (
            <TextField
                fullWidth={true}
                InputProps={{
                    inputRef: ref,
                    classes: {
                        input: classes.input,
                    },
                    ...other,
                }}
            />
        );
    }
    
    renderSuggestion(suggestion, { query, isHighlighted }) {
        const matches = match(this.getSuggestionValue(suggestion), query);
        const parts = parse(this.getSuggestionValue(suggestion), matches);
    
        return (
            <MenuItem selected={isHighlighted} component="div">
                <div>
                    {parts.map((part, index) => {
                        return part.highlight ? (
                            <span key={String(index)} style={{ fontWeight: 500 }}>
                                {part.text}
                            </span>
                        ) : (
                                <strong key={String(index)} style={{ fontWeight: 300 }}>
                                    {part.text}
                                </strong>
                            );
                    })}
                </div>
            </MenuItem>
        );
    }
    
    renderSuggestionsContainer(options) {
        const { containerProps, children } = options;
    
        return (
            <Paper {...containerProps} square={true}>
                {children}
            </Paper>
        );
    }
    
    getSuggestionValue(suggestion: Customer) {
        return suggestion.firstname + " " + suggestion.lastname;
    }
    
    getSuggestions(value): Customer[] {
        const inputValue = this.clean(value);
        const inputLength = inputValue.length;
        let count = 0;
        return inputLength === 0
            ? []    
            : this.props.autocompleteCustomers.filter(suggestion => {
                const keep =
                    count < 5 && ( this.clean(suggestion.firstname).slice(0, inputLength) === inputValue || this.clean(suggestion.lastname).slice(0, inputLength) === inputValue);
    
                if (keep) {
                    count += 1;
                }
    
                return keep;
            });
    }

    render() {
        const { classes } = this.props;

        return (
            <div style={{position: "relative"}}>
                <SearchIcon style={{ position: "absolute", right: 0 }} />
                <Autosuggest
                    theme={{
                        container: classes.container,
                        suggestionsContainerOpen: classes.suggestionsContainerOpen,
                        suggestionsList: classes.suggestionsList,
                        suggestion: classes.suggestion,
                    }}
                    renderInputComponent={this.renderInput.bind(this)}
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested.bind(this)}
                    onSuggestionsClearRequested={this.handleSuggestionsClearRequested.bind(this)}
                    renderSuggestionsContainer={this.renderSuggestionsContainer.bind(this)}
                    getSuggestionValue={this.getSuggestionValue.bind(this)}
                    renderSuggestion={this.renderSuggestion.bind(this)}
                    onSuggestionSelected={this.handleSuggestionSelected.bind(this)}
                    inputProps={{
                        classes,
                        placeholder: this.props.placeholder,
                        value: this.state.value,
                        onChange: this.handleChange.bind(this),
                    }}
                />
            </div>
        );
    }

    clean(value: string) {
        const withoutAccents = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return withoutAccents.trim().toLowerCase();
    }
}

export default withStyles(styles)(InputCustomerAutocomplete);



// WEBPACK FOOTER //
// ./src/components/InputCustomerAutocomplete/InputCustomerAutocomplete.tsx